import { render } from "./InventorySummaryItem.vue?vue&type=template&id=e7d06a3a&scoped=true&ts=true"
import script from "./InventorySummaryItem.vue?vue&type=script&lang=ts"
export * from "./InventorySummaryItem.vue?vue&type=script&lang=ts"

import "./InventorySummaryItem.vue?vue&type=style&index=0&id=e7d06a3a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7d06a3a"]])

export default __exports__